import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { motion } from "framer-motion";
import { XCircle, ArrowLeft, LifeBuoy, RefreshCw } from "lucide-react";
import WeKitLogo from "@/components/WeKitLogo";

const PaymentFailure = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const reason = params.get("reason") || "Your payment could not be completed.";
  const orderId = params.get("order") || "";

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 py-8">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
        className="w-full max-w-md"
      >
        <Card className="border-destructive/30 bg-card/80 backdrop-blur text-center">
          <CardContent className="pt-10 pb-8 px-6 space-y-6">
            <div className="mx-auto w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center">
              <XCircle className="h-10 w-10 text-destructive" />
            </div>
            <div>
              <h1 className="font-display text-2xl sm:text-3xl font-bold mb-2">
                Payment unsuccessful
              </h1>
              <p className="text-sm text-muted-foreground">{reason}</p>
              {orderId && (
                <p className="text-xs font-mono text-muted-foreground mt-2 break-all">
                  Order: {orderId}
                </p>
              )}
            </div>
            <div className="rounded-lg border border-border bg-muted/30 p-4 text-left text-xs text-muted-foreground space-y-2">
              <p className="font-medium text-foreground">No charge was made.</p>
              <p>If your bank shows a charge, it will auto-reverse within 5–7 business days.</p>
              <p>You can retry the payment safely — duplicates won't happen.</p>
            </div>
            <div className="space-y-3">
              <Button onClick={() => navigate("/payment")} className="w-full h-12 text-base font-semibold" size="lg">
                <RefreshCw className="h-5 w-5" />
                Try again
              </Button>
              <div className="grid grid-cols-2 gap-2">
                <Button variant="outline" onClick={() => navigate("/")}>
                  <ArrowLeft className="h-4 w-4" /> Home
                </Button>
                <Button variant="ghost" asChild>
                  <a href={`mailto:support@wekit.ai?subject=Payment%20failed&body=Order%3A%20${encodeURIComponent(orderId)}`}>
                    <LifeBuoy className="h-4 w-4" /> Support
                  </a>
                </Button>
              </div>
            </div>
            <div className="pt-4 border-t border-border/50">
              <WeKitLogo size="sm" />
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};

export default PaymentFailure;
